var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[(!!_vm.selectModel(_vm.modelValue ,_vm.dataSelectorKey))?_c('span',{staticClass:"text--secondary text-body-1"},[_vm._v(" "+_vm._s(_vm._f("phone")(_vm.selectModel(_vm.modelValue ,_vm.dataSelectorKey))))]):_c('span',[_vm._v("--")])])
}
var staticRenderFns = []

export { render, staticRenderFns }